import { render, staticRenderFns } from "./CodeMessageList.vue?vue&type=template&id=4ee952e7&"
import script from "./CodeMessageList.vue?vue&type=script&lang=js&"
export * from "./CodeMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports